import { Box, Icon, Modal } from '@sendible/design-system/src';
import { styled, css } from 'styled-components';

export const ModalComponent = styled(Modal)`
  font-size: 14px; // reset for cross-app consistency
`;

export const ModalHeading = styled.div`
  align-items: center;
  display: flex;
`;

export const HeadingIcon = styled(Icon)`
  margin-right: 0.5rem;
`;

export const Container = styled.div`
  flex: 1;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  .input {
    flex: 1;

    input {
      margin: 0;
    }
  }

  .right-icon {
    display: none;
  }
`;

export const RowContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;

  > :last-child {
    flex: 1;
    width: 100%;
  }
`;

export const FullWidth = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  > * {
    width: 100%;
  }
`;

export const NotificationOptions = styled.div`
  display: flex;
  gap: 0.75rem;
  width: 100%;
`;

export const NotificationCard = styled.button<{ $selected?: boolean }>`
  ${({ theme: { colors }, $selected }) => css`
    background: ${$selected ? '#f3f3ff' : '#fff'};
    border: 1px solid ${$selected ? colors.brandPrimary : '#e3e3e3'};
    border-radius: 6px;
    cursor: pointer;
    flex: 1;
    padding: 0.75rem 0.75rem 0.6rem 0.75rem;
    text-align: left;
    display: flex;
    flex-direction: column;
    min-height: 90px;

    &:hover {
      border-color: ${colors.brandPrimary};
    }

    .header {
      display: flex;
      align-items: flex-start;
      gap: 0.5rem;
      margin-bottom: 0.25rem;
    }

    .radio-label-wrapper {
      display: flex;
      flex-direction: column;
    }

    .title {
      align-items: center;
      color: ${colors.brandDark};
      display: flex;
      font-size: 0.85rem;
      font-weight: 600;
      gap: 0.5rem;
      margin: 0 0 0.25rem 0;
    }

    .desc {
      color: ${colors.brandDarkTint30};
      font-size: 0.75rem;
      font-weight: 500;
      line-height: 1rem;
      margin: 0;
    }

    .link {
      color: ${colors.brandPrimary};
      display: inline-block;
      font-size: 0.7rem;
      font-weight: 600;
      margin-top: 0.25rem;
      text-decoration: none;
    }

    .native-radio-wrapper {
      display: flex;
      align-items: flex-start;
      gap: 0.5rem;
      margin-bottom: 0.25rem;
    }
  `}
`;

export const NotificationRadio = styled.div<{ $selected?: boolean }>`
  ${({ theme: { colors }, $selected }) => css`
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    margin-bottom: 0.25rem;

    &:focus {
      outline: none !important;
    }

    &:checked {
      background: ${colors.brandPrimary};
      border-color: ${colors.brandPrimary};
    }

    input {
      appearance: none;
      -webkit-appearance: none;
      border: ${$selected ? '6px' : '1px'} solid ${$selected ? colors.brandPrimary : '#c8c8c8'};
      border-radius: 50%;
      cursor: pointer;
      height: 18px;
      margin: 2px 0 0 0;
      position: relative;
      width: 18px;
      transition:
        border-color 0.15s,
        background 0.15s;
    }

    .icon-span {
      font-family: sans-serif;
      font-variant-emoji: none;
      float: none;
      margin: 0;
    }
  `}
`;

export const InputHeader = styled.div`
  ${({ theme: { colors } }) => css`
    color: ${colors.brandDark};
    font-size: 0.75rem;
    font-weight: 500;
    line-height: 1rem;
    margin-bottom: 0.25rem;
  `}
`;

export const ProfileSubText = styled.div`
  ${({ theme: { colors } }) => css`
    color: ${colors.brandDark};
    font-size: 0.75rem;
    text-align: right;
  `}
`;

export const NotifySubText = styled.div`
  ${({ theme: { colors } }) => css`
    color: ${colors.brandDarkTint30};
    font-size: 0.75rem;
  `}
`;

export const SubText = styled(NotifySubText)``;

export const FooterContainer = styled(Box)`
  gap: 0.5rem;
`;

export const SkeletonCardsRow = styled.div`
  display: flex;
  gap: 0.75rem;
  width: 100%;
`;

export const SkeletonCard = styled.div`
  border: 1px solid #e3e3e3;
  border-radius: 6px;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.75rem;
`;

export const SkeletonCardHeader = styled.div`
  align-items: flex-start;
  display: flex;
  gap: 0.5rem;
`;

export const SkeletonCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  width: 100%;
`;

export const SkeletonRightAligned = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
`;
